import { match } from 'ts-pattern'

import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepContentElement } from '@flows/core/types/stepContentTypes'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'

const dental_quote = (params: StepConfigParams, plaform: 'native' | 'web') => {
  const platformContent = match(plaform)
    .returnType<AnyStepContentElement[]>()
    .with('native', () => [
      {
        type: 'infoBox',
        noPadding: true,
        bgColor: 'grey200',
        contentConfiguration: [
          {
            type: 'title',
            size: 'h4',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.general_notice.title',
            },
          },
          {
            type: 'text',
            emphasis: 'default',
            style: 'caption',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_dental:steps.general_notice.description',
            },
          },
        ],
      },
      {
        type: 'spacer',
        size: 'small',
      },
    ])
    .otherwise(() => [])

  return {
    stepContent: [
      {
        type: 'customComponent',
        name: 'QuoteStep',
        props: {
          product: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
      ...platformContent,
    ],
    nextStep: 'dental_personal_details',
    onPrepare: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'prepareQuoteStep',
        options: {
          productKey: params.productKey,
        },
        inputs: [],
        outputs: [],
      },
    },
    showOrderSummary: true,
    nonStickyFooter: true,
    subFlow: params.subFlow,
  } as const satisfies AnyStepConfiguration
}

export default dental_quote
